/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import React from "react";
import Mention from './components/Mention';
import { apiAction } from '../../../../../api/api';
import MentionsInput from './components/MentionsInput';
import { isNumeric } from '../../../../../utils/Utils';
import { list_of_data_point } from '../../../../../api/urls';
import { getBusinessInfo } from '../../../../../config/cookiesInfo';
import { LabelWithAsteriskMark } from '../../../../common/CommonLabel';
import CustomTypography from '../../../../custom/typography/CustomTypography';
import { mentionsInputWrapperStyle, mentionStyle } from "./QueryWrapperStyle";
// import { CustomRenderSuggestion, CustomSuggestionsContainer } from './CustomSuggestion';

import {
  cleanString,
  splitExpression,
  getUniqueObjects,
  replaceStringWithSlug,
  replaceSlugWithString,
} from '../common/Helper';

const Query = ({
  data,
  getData,
  isFormulaValid,
}) => {
  const [nextUrl, setNextUrl] = React.useState();
  const [results, setResults] = React.useState([]);
  const [searchText, setSearchText] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [mentionData, setMentionData] = React.useState([]);
  const [textAreaValue, setTextAreaValue] = React.useState('');
  const [accountSelected, setAccountSelected] = React.useState([]);

  const business_id = getBusinessInfo().id;
  const API_ENDPOINT = list_of_data_point(business_id) + '&sort_by=data_point_type&sort_order=A';


  const fetchData = async (url = API_ENDPOINT, previousResults = []) => {

    setIsLoading(true);
    if (!url) return;

    try {
      const res = await apiAction({
        url,
      });

      if (!res?.success) {
        setIsLoading(false);
        console.error("Error fetching data:", res);
        return;
      }

      const newResults = getUniqueObjects([...previousResults, ...res?.result?.result]).map((obj) => ({
        ...obj,
        display: obj.name,
      }));
      setNextUrl(res?.result?.next);
      setResults([...newResults]);
      setIsLoading(false);
      return newResults;
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
      console.error('Fetch error:', error);
      setIsLoading(false);
    }
  };

  const onChangeHandler = (event, newValue, newPlainTextValue, mentions) => {
    setTextAreaValue(event.target.value);
  };

  const onItemSelected = (id) => {
    const newAccount = results.find((obj) => obj.id === id);
    if (!newAccount) return;
    const equation = replaceStringWithSlug(textAreaValue, accountSelected);
    const splitExpressionArray = typeof equation === 'string' ? splitExpression(equation) : [];
    const selectedAccount = splitExpressionArray.length ? accountSelected.filter((item) => item ? splitExpressionArray.includes(item.slug_name) : false) : [];
    setAccountSelected(getUniqueObjects([...selectedAccount, newAccount]));
    setSearchText('');
  };


  const getFinalData = (equation = '', accounts = []) => {
    const splitExpressionArray = typeof equation === 'string' ? splitExpression(equation) : [];
    if (splitExpressionArray.length) {
      const selectedAccount = accounts.filter((item) => item ? splitExpressionArray.includes(item.slug_name) : false);
      const unknownAccount = splitExpressionArray.filter(element => isNumeric(element) ? false : !accounts?.some(item => item && item.slug_name === element));

      getData({
        getAccounts: getUniqueObjects([...accounts]),
        unknownAccount: getUniqueObjects([...unknownAccount]),
        equation: replaceSlugWithString(equation, selectedAccount),
        getCalculationFormula: replaceStringWithSlug(equation, selectedAccount),
        getDataPointDependenciesId: getUniqueObjects([...selectedAccount]).map(item => item.id),
      });
    } else {
      getData({
        equation: null,
        getAccounts: [],
        unknownAccount: [],
        getCalculationFormula: null,
        getDataPointDependenciesId: [],
      });
    }
  };

  React.useEffect(() => {
    getFinalData(replaceStringWithSlug(textAreaValue, accountSelected), accountSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, accountSelected]);

  React.useEffect(() => {
    if (data) {
      const equationText = replaceSlugWithString(data.calculation_formula, data.data_point_dependencies);
      const arrangedAccounts = data.calculation_formula && splitExpression(data.calculation_formula).map(slug_name => isNumeric(slug_name) ? false : data.data_point_dependencies.find(item => item.slug_name === slug_name));

      if (data.calculation_type === 'equation') {
        setTextAreaValue(equationText || '');
      }
      setAccountSelected(arrangedAccounts || []);
    }
  }, [data]);

  const fetchMentionData = React.useCallback(
    _.debounce(async (query, isNextPage = false) => {
      let newResults;
      setSearchText(cleanString(query));
      try {
        if (isNextPage && nextUrl) {
          newResults = await fetchData(`${nextUrl}&business_id=${business_id}&name=${cleanString(query) || ''}&sort_by=data_point_type&sort_order=A`, results);
        } else {
          newResults = await fetchData(
            list_of_data_point(business_id, cleanString(query), []) + `&sort_by=data_point_type&sort_order=A`
          );
        }
        setMentionData(newResults || []);
      } catch (error) {
        console.error('Error in fetchMentionData:', error);
        setMentionData([]);
      }
    }, 300),
    [nextUrl, results]
  );

  const handleQueryChange = (query) => {
    fetchMentionData(query);
  };

  const keyDownEvent = React.useRef(null);
  const handleKeyDown = (event) => {
    keyDownEvent.current = event;
  }
  return (
    <div>
      <CustomTypography
        text={<span><LabelWithAsteriskMark label={'Calculation Formula'} /> <span style={{ insetInlineStart: '5px', opacity: .5 }}>Mention accounts using '@' + account name</span></span>}
        sx={{
          mb: 1,
          color: '#000000',
          fontSize: '14px',
          fontWeight: '700',
          blockSize: '18px',
          fontStyle: 'normal',
          textTransform: 'none',
          fontFamily: "Noto Sans",
        }}
      />
      <MentionsInput
        value={textAreaValue}
        allowSpaceInQuery={true}
        groupBy="data_point_type"
        mentionData={mentionData}
        onChange={onChangeHandler}
        id="mentions_input_text_area"
        onQueryChange={handleQueryChange}
        allowSuggestionsAboveCursor={true}
        forceSuggestionsAboveCursor={true}
        dataTestId="mentions_input_text_area"
        placeholder="To mention the accounts use '@'"
        style={{ ...mentionsInputWrapperStyle(isFormulaValid) }}
        className={isFormulaValid ? 'mentions_input_error' : 'mentions_input'}
        onScroll={(event) => {
          event.preventDefault();
          const { scrollTop, scrollHeight, clientHeight } = event.target;
          if (scrollTop + clientHeight >= scrollHeight - 10 && nextUrl && !isLoading) {
            fetchMentionData(searchText, true);
          }
        }}
      >
        <Mention
          trigger={'@'}
          ignoreAccents={false}
          isLoading={isLoading}
          appendSpaceOnAdd={true}
          onAdd={(id) => { onItemSelected(id) }}
          style={{ ...mentionStyle(isFormulaValid) }}
        />
      </MentionsInput>
    </div>
  );
};


export default Query;